import Vue from 'vue'
import App from './App.vue'
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import BootstrapVue from "bootstrap-vue";
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import VuetifyDialog from 'vuetify-dialog';
import 'vuetify-dialog/dist/vuetify-dialog.css';
import VueRouter from 'vue-router'
import {routes} from './router/index.js'
import store from './store'
import  mainStore  from './store/modules/mainStore.js';
//PLUGINS
import vuetify from './plugins/vuetify';
import './plugins/clipboard';

Vue.config.productionTip = false

Vue.use(BootstrapVue);
Vue.use(Vuetify);
Vue.use(VuetifyDialog);
Vue.use(VueRouter);

//Change Country code for northerncontainersales.com to CA. 
const servername = window.location.hostname;
var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
link.type = 'image/png';
link.rel = 'icon';

//Change favicon based on country code.
if (servername.includes('northerncontainersales')) {
  link.href = 'https://images-ncs.s3-us-west-2.amazonaws.com/favicon.ico';
  mainStore.state.country_code = 'CA'
}
else {
  link.href = 'https://images-wcs.s3-us-west-2.amazonaws.com/New-Western-Container-Sales-Favicon-Logo-Shipping-Containers-For-Sale-Conex-Box-Rent-Storage-Container-514px-square.png';
  mainStore.state.country_code = 'US'
}
document.getElementsByTagName('head')[0].appendChild(link);

//setting the title of the page
const pathname = window.location.pathname;
var pageTitle = "";
switch(pathname){
  case '/RentalPickup':pageTitle = 'Rental Pickup Request';break;
  case '/contact':pageTitle = 'Contact Request Form';break;
  case '/CreditApplication':pageTitle = 'Credit Application Form';break;
  case '/CustomerPickup':pageTitle = 'Customer Pickup Request';break;
  case '/Delivery':pageTitle = 'Delivery Form';break;
  case '/DeliveryDateConfirmation':pageTitle = 'Delivery Date Confirmation';break;
  case '/RailboxContact':pageTitle = 'Railbox Contact Request';break;
  case '/RentalDelivery':pageTitle = 'Rental Delivery Request';break;
  case '/WholesaleQuote':pageTitle = 'Wholesale Quote Form';break;
}
if (window.location.hostname.includes('northerncontainersales'))
      window.document.title = `${pageTitle} - Northern Container Sales`;
    else
      window.document.title = `${pageTitle} - Western Container Sales`;

Vue.filter('phoneNumberFilter', function(value) {
  if (value) {
    var x = value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
    value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
    return value;
  }
});

Vue.filter('upperCase', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
});

const router = new VueRouter({
  mode: 'history',
  routes
})

new Vue({  
  vuetify,
  router,
  store,
  render: h => h(App),
}).$mount('#app')
